module.exports = {"120102001":"大王庄街道","120102002":"大直沽街道","120102003":"中山门街道","120102004":"富民路街道","120102005":"二号桥街道","120102006":"春华街道","120102007":"唐家口街道","120102008":"向阳楼街道","120102009":"常州道街道","120102010":"上杭路街道","120102011":"东新街道","120102012":"鲁山道街道","120102013":"天津铁厂街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/120102.json
// module id = 41
// module chunks = 0